import api from "./api";
import { getUserTimezone } from "../utils/timezone";

const getConfig = () => ({
  headers: {
    "X-Timezone": getUserTimezone(),
  },
});

// Get todos for today (includes overdue carryover)
const getTodos = async () => {
  const response = await api.get(`/api/todos`, getConfig());
  return response.data;
};

// Create new todo
const createTodo = async (text, deadline = null) => {
  const response = await api.post(
    `/api/todos`,
    { text, deadline },
    getConfig()
  );
  return response.data;
};

// Toggle todo completion
const toggleTodo = async (id, completed) => {
  const response = await api.put(
    `/api/todos/${id}`,
    { completed },
    getConfig()
  );
  return response.data;
};

// Update todo fields (text, etc.)
const updateTodo = async (id, updates) => {
  const response = await api.put(`/api/todos/${id}`, updates, getConfig());
  return response.data;
};

// Delete todo
const deleteTodo = async (id) => {
  const response = await api.delete(
    `/api/todos/${id}`,
    getConfig()
  );
  return response.data;
};

// Clear all completed todos
const clearCompleted = async () => {
  const response = await api.delete(
    `/api/todos/clear-completed`,
    getConfig()
  );
  return response.data;
};

const todoService = {
  getTodos,
  createTodo,
  toggleTodo,
  updateTodo,
  deleteTodo,
  clearCompleted,
  deleteAll: async () => {
    const response = await api.delete(`/api/todos/delete-all`, getConfig());
    return response.data;
  },
  getDeletedTodos: async () => {
    const response = await api.get(`/api/todos/deleted`, getConfig());
    return response.data;
  },
  restoreTodo: async (id) => {
    const response = await api.put(`/api/todos/${id}/restore`, {}, getConfig());
    return response.data;
  },
  markTodoMissed: async (id, missed) => {
    const response = await api.put(`/api/todos/${id}/missed`, { missed }, getConfig());
    return response.data;
  },
  getMissedTodos: async () => {
    const response = await api.get(`/api/todos/missed`, getConfig());
    return response.data;
  },
  clearMissed: async () => {
    const response = await api.delete(`/api/todos/clear-missed`, getConfig());
    return response.data;
  },
  rescheduleTodo: async (id, deadline) => {
    // Re-remind: move to a new date and clear the missed flag
    const response = await api.put(
      `/api/todos/${id}`,
      { deadline, date: deadline, missed: false },
      getConfig()
    );
    return response.data;
  },
  reorderTodos: async (order) => {
    // order = [{ id, sortOrder }, ...]
    const response = await api.put(`/api/todos/reorder`, { order }, getConfig());
    return response.data;
  },
};

export default todoService;
